import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ContextSession } from './ContextSession';

const ProtectedRoute = ({ children }) => {
  const { getToken, sessionData } = useContext(ContextSession);
  const location = useLocation();
  const token = getToken();
  const requiresPasswordChange = Number(sessionData?.cambiarPw) === 0;

  if (!token || token === "NA") {
    // Si no hay token, redirige al login
    return <Navigate to="/" replace />;
  }

  if (requiresPasswordChange && location.pathname !== "/CambioClave") {
    return <Navigate to="/CambioClave" replace />;
  }

  return children;
};

export default ProtectedRoute;
